import { render, staticRenderFns } from "./Pozicovna.vue?vue&type=template&id=0c95bec0&scoped=true&"
import script from "./Pozicovna.vue?vue&type=script&lang=js&"
export * from "./Pozicovna.vue?vue&type=script&lang=js&"
import style0 from "./Pozicovna.vue?vue&type=style&index=0&id=0c95bec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c95bec0",
  null
  
)

export default component.exports